(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68810],{

/***/ 77877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Benefits; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90010);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85523);





function Benefits() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col lg:flex-row lg:gap-36 gap-8 lg:pt-28 pt-14 lg:pb-[93px] pb-[50px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-[550px] mx-auto lg:mx-0 order-2 lg:mt-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-[#1B6658] ",
                            children: "The Benefits of Choosing DebtReliefOasis.com"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                            children: "Financial Liberation"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "font-light lg:text-lg text-base lg:leading-8 ",
                            children: "Selecting a debt relief company brings a multitude of advantages for those wrestling with overwhelming debt. These companies specialize in negotiating with creditors to secure reduced debt amounts, lower interest rates, or more manageable repayment terms. With their guidance, you can find solace and freedom from the shackles of unmanageable debt."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-6 text-center sm:text-left",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                children: "I am Ready to Be Debt-Free"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-[271px] h-[263px] md:w-[510px] md:min-w-[510px] md:h-[547px] relative mx-auto lg:mx-0 order-1 ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/debtreliefoasis/assets/images/benefitsImg.png",
                        alt: "Image",
                        layout: "fill"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 1552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DebtFreePath; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85523);




function DebtFreePath() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-40 gap-8 lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[550px] mx-auto lg:mx-0 order-2 lg:order-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] text-[#1B6658] ",
                        children: "DebtReliefOasis.com: Your Path to a Debt-Free Life"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-7 font-light lg:text-lg text-base lg:leading-8 ",
                        children: "Are you grappling with insurmountable debt? Debt relief companies are your expert companions on the journey to financial freedom. Their mission is simple: to provide pragmatic solutions to alleviate your financial burdens. They offer an array of services, including negotiating with creditors to reduce your total debt, streamlining multiple debts into a single manageable payment, offering credit counseling to impart financial wisdom, and guiding you through potential bankruptcy proceedings if necessary."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-4 font-light lg:text-lg text-base lg:leading-8 ",
                        children: "These companies work closely with you to design personalized debt repayment strategies, negotiate lower interest rates on your behalf, and explore legal options for financial respite. The ultimate objective is to empower you to regain control of your financial destiny and pave the way for a debt-free future."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-6 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            children: "Get Your Free Financial Consultation Now"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[271px] h-[263px] md:w-[555px] md:min-w-[555px] md:h-[567px] relative mx-auto lg:mx-0 order-1 lg:order-2 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/debtreliefoasis/assets/images/debtFreePathImg.png",
                    alt: "Image",
                    layout: "fill"
                })
            })
        ]
    });
}


/***/ }),

/***/ 18948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FinancialResiliencePath; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/debtreliefoasis/financialResiliencePath/style.module.scss
var style_module = __webpack_require__(65748);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
// EXTERNAL MODULE: ./src/components/debtreliefoasis/sharedButton/index.tsx
var sharedButton = __webpack_require__(85523);
;// CONCATENATED MODULE: ./src/components/debtreliefoasis/financialResiliencePath/icons/comprehensiveFinancialAssessment.tsx


function ComprehensiveFinancialAssessment() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "40",
        fill: "none",
        viewBox: "0 0 41 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#1B6658",
            fillRule: "evenodd",
            d: "M20.044 38.667C9.75 38.667 1.376 30.293 1.376 20c0-10.293 8.375-18.667 18.668-18.667S38.71 9.708 38.71 20c0 10.293-8.373 18.667-18.666 18.667zm0-38.667c-11.029 0-20 8.972-20 20s8.971 20 20 20c11.028 0 20-8.972 20-20s-8.972-20-20-20zm0 35.02c8.282 0 15.019-6.737 15.019-15.02 0-8.281-6.737-15.02-15.02-15.02-8.282 0-15.02 6.739-15.02 15.02 0 8.283 6.738 15.02 15.02 15.02zm0-31.373C11.027 3.647 3.69 10.983 3.69 20c0 9.017 7.337 16.353 16.354 16.353S36.396 29.017 36.396 20c0-9.017-7.335-16.353-16.352-16.353zm8.333 11.983a1.26 1.26 0 00-1.78-1.78L17.6 22.846a.669.669 0 01-.993-.056l-3.028-3.81a1.25 1.25 0 00-1.763-.202 1.246 1.246 0 00-.466.84c-.038.333.056.66.264.924l4.294 5.403a1.266 1.266 0 001.062.573c.334 0 .65-.13.887-.368l10.52-10.52zm-.89-3.482c-.693 0-1.344.27-1.834.76l-8.467 8.467-2.563-3.225a2.576 2.576 0 00-2.027-.978c-.582 0-1.154.2-1.61.563a2.57 2.57 0 00-.961 1.732 2.573 2.573 0 00.545 1.904l4.282 5.389a2.6 2.6 0 002.117 1.091c.69 0 1.34-.27 1.83-.759l10.52-10.519a2.595 2.595 0 000-3.666 2.572 2.572 0 00-1.832-.759z",
            clipRule: "evenodd"
        })
    });
}
/* harmony default export */ var comprehensiveFinancialAssessment = (ComprehensiveFinancialAssessment);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/financialResiliencePath/icons/personalizedDebtReliefPlan.tsx


function PersonalizedDebtReliefPlan() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        fill: "none",
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M27.747 22.442c-.673-1.726-2.02-3.032-3.663-3.79A5.461 5.461 0 0019.958 9.6a5.463 5.463 0 00-5.474 5.474c0 1.39.505 2.61 1.348 3.579-1.643.758-2.99 2.105-3.664 3.79a20.074 20.074 0 00-1.136 4.42c-.085.842.126 1.684.673 2.274a2.785 2.785 0 002.148.968h12.126c.842 0 1.6-.337 2.147-.968a2.788 2.788 0 00.716-1.895c0-.126 0-.253-.042-.379-.084-1.558-.463-3.031-1.053-4.42zM20 11.452c1.979 0 3.579 1.6 3.579 3.58 0 1.979-1.6 3.578-3.579 3.578a3.576 3.576 0 01-3.579-3.578c0-1.98 1.6-3.58 3.579-3.58zm6.821 16.422c-.168.21-.463.337-.758.337H13.937c-.295 0-.59-.127-.758-.337a1.055 1.055 0 01-.21-.8 16.087 16.087 0 011.01-3.958c.632-1.6 2.063-2.737 3.705-3.116a5.326 5.326 0 002.316.505c.842 0 1.6-.21 2.316-.505 1.684.379 3.116 1.558 3.705 3.116.505 1.263.842 2.61 1.01 3.958.043.294-.041.59-.21.8z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M39.074 19.074h-1.642c-.464-8.885-7.622-16-16.506-16.506V.926A.935.935 0 0020 0a.935.935 0 00-.926.926v1.642c-8.885.464-16.042 7.622-16.506 16.506H.926A.935.935 0 000 20c0 .505.421.926.926.926h1.642c.464 8.885 7.622 16 16.506 16.506v1.642c0 .505.42.926.926.926a.935.935 0 00.926-.926v-1.642c8.885-.464 16-7.622 16.506-16.506h1.642A.935.935 0 0040 20a.935.935 0 00-.926-.926zM20.926 35.537v-1.558a.935.935 0 00-.926-.926.935.935 0 00-.926.926v1.558c-7.832-.463-14.106-6.737-14.61-14.61H6.02A.934.934 0 006.947 20a.934.934 0 00-.926-.926H4.463c.463-7.832 6.737-14.106 14.61-14.61v1.515c0 .505.422.926.927.926a.934.934 0 00.926-.926V4.463c7.832.463 14.106 6.737 14.61 14.61h-1.515a.935.935 0 00-.926.927c0 .505.42.926.926.926h1.516c-.463 7.832-6.78 14.148-14.61 14.61z"
            })
        ]
    });
}
/* harmony default export */ var personalizedDebtReliefPlan = (PersonalizedDebtReliefPlan);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/financialResiliencePath/icons/negotiatingFinancialRelief.tsx


function NegotiatingFinancialRelief() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        fill: "none",
        viewBox: "0 0 40 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#1B6658",
            d: "M33.778 16h-4.445V6.222A6.229 6.229 0 0023.111 0H6.222A6.23 6.23 0 000 6.222v11.556A6.229 6.229 0 006.222 24h4.445v13.333A2.669 2.669 0 0013.333 40h20.445A6.229 6.229 0 0040 33.778V22.222A6.229 6.229 0 0033.778 16zM6.222 22.222a4.452 4.452 0 01-4.444-4.444V6.222a4.452 4.452 0 014.444-4.444h16.89a4.452 4.452 0 014.444 4.444v15.111c0 .49-.4.89-.89.89H6.223zm32 11.556a4.452 4.452 0 01-4.444 4.444H13.333a.892.892 0 01-.889-.889V24h14.223a2.669 2.669 0 002.666-2.667v-3.555h4.445a4.452 4.452 0 014.444 4.444v11.556zM33.778 28c0 .489-.4.889-.89.889H18.668a.892.892 0 01-.89-.889c0-.489.4-.889.89-.889h14.222c.489 0 .889.4.889.889zm0 4.444c0 .49-.4.89-.89.89H18.668a.892.892 0 01-.89-.89c0-.488.4-.888.89-.888h14.222c.489 0 .889.4.889.888zM22.222 12c0 .489-.4.889-.889.889H7.111A.892.892 0 016.222 12c0-.489.4-.889.89-.889h14.221c.49 0 .89.4.89.889zm-16-4.444c0-.49.4-.89.89-.89h6.221c.49 0 .89.4.89.89 0 .488-.4.888-.89.888H7.111a.892.892 0 01-.889-.888zm16 8.888c0 .49-.4.89-.889.89H7.111a.892.892 0 01-.889-.89c0-.488.4-.888.89-.888h14.221c.49 0 .89.4.89.888z"
        })
    });
}
/* harmony default export */ var negotiatingFinancialRelief = (NegotiatingFinancialRelief);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/financialResiliencePath/icons/regularPayments.tsx


function RegularPayments() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "51",
        height: "40",
        fill: "none",
        viewBox: "0 0 51 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M22.705 25.94c-.875 0-1.586-.603-1.586-1.369s.71-1.367 1.586-1.367c.876 0 1.587.601 1.587 1.367 0 .438.383.821.82.821.438 0 .821-.383.821-.82 0-1.423-1.04-2.572-2.407-2.9v-1.423a.841.841 0 00-.82-.82.841.841 0 00-.822.82v1.423c-1.367.328-2.407 1.532-2.407 2.9 0 1.695 1.423 3.009 3.228 3.009.876 0 1.587.601 1.587 1.367s-.711 1.368-1.587 1.368c-.875 0-1.586-.602-1.586-1.368a.841.841 0 00-.821-.82.841.841 0 00-.82.82c0 1.423 1.039 2.572 2.406 2.9v1.422c0 .438.383.821.821.821.438 0 .82-.383.82-.82v-1.423c1.369-.328 2.408-1.532 2.408-2.9 0-1.641-1.477-3.009-3.228-3.009z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M44.59 40H.82a.841.841 0 01-.82-.82V14.284c0-.437.383-.82.82-.82h43.77c.438 0 .82.383.82.82V39.18c0 .493-.382.82-.82.82zM1.64 38.358H43.77V15.107H1.641v23.252z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M37.696 36.608h-5.143a.841.841 0 01-.82-.82c0-.438.383-.821.82-.821h4.815l3.118-2.681V21.234l-3.118-2.68h-4.815a.841.841 0 01-.82-.822c0-.437.383-.82.82-.82h5.143c.219 0 .383.054.547.219l3.611 3.118a.879.879 0 01.274.602v11.818c0 .218-.11.437-.274.601l-3.61 3.119a.703.703 0 01-.548.219zM12.857 36.608H7.714a.703.703 0 01-.547-.219l-3.61-3.119a.879.879 0 01-.274-.601V20.85c0-.219.11-.492.273-.602l3.611-3.118c.164-.11.328-.22.547-.22h5.143c.438 0 .82.384.82.821 0 .438-.382.821-.82.821H8.043l-3.119 2.68v11.053l3.119 2.68h4.814c.438 0 .82.383.82.821 0 .438-.382.82-.82.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M22.705 36.608c-5.416 0-9.848-4.432-9.848-9.848 0-5.417 4.432-9.848 9.848-9.848 5.417 0 9.848 4.431 9.848 9.848 0 5.416-4.431 9.848-9.848 9.848zm0-18.055A8.196 8.196 0 0014.5 26.76a8.196 8.196 0 008.206 8.207 8.196 8.196 0 008.207-8.207 8.196 8.196 0 00-8.207-8.207zM23.252 12.918h2.353c.11-.055.219-.055.328-.055.274-.055.547 0 .82.055h2.299c-.438-.93-1.423-1.587-2.517-1.696l-.219-1.368c-.055-.438-.492-.766-.93-.711-.438.054-.766.492-.711.93l.219 1.368c-.712.328-1.259.875-1.642 1.477z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M50.772 25.337L47.106.717c-.054-.437-.492-.766-.93-.711L2.845 6.516c-.438.055-.766.493-.657.93l.766 5.472h1.642l-.712-4.924 41.69-6.237 3.447 22.978-3.063.438v1.642l4.103-.602c.438 0 .766-.383.711-.876z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M35.015 6.845l4.76-.711 3.447 2.188.711 4.596h.657c.438 0 .82.219 1.04.492l-.876-5.744c-.055-.22-.164-.438-.383-.547l-4.049-2.572c-.164-.11-.383-.164-.547-.11l-5.088.767c-.438.054-.766.492-.711.93.164.492.547.766 1.04.711zM19.04 12.918c1.149-2.407 3.392-4.213 6.182-4.65 3.666-.548 7.112 1.422 8.644 4.65h1.806c-1.587-4.213-6.018-6.949-10.669-6.237-3.666.547-6.51 3.009-7.769 6.237h1.805zM8.59 12.918l2.133-2.462 4.76-.711c.438-.055.766-.493.712-.93-.055-.438-.493-.766-.93-.712l-5.089.766c-.219.055-.383.11-.492.274l-3.119 3.61c-.054.055-.054.11-.11.165H8.59z"
            })
        ]
    });
}
/* harmony default export */ var regularPayments = (RegularPayments);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/financialResiliencePath/icons/achievingFinancialFreedom.tsx


function AchievingFinancialFreedom() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "29",
        height: "40",
        fill: "none",
        viewBox: "0 0 29 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M27.956 18.889H5.733v-8.045c0-4.844 3.956-8.8 8.8-8.8 4.845 0 8.8 3.956 8.8 8.8 0 .578.445 1.023 1.023 1.023.577 0 1.022-.445 1.022-1.023C25.333 4.844 20.444 0 14.488 0 8.534 0 3.645 4.844 3.645 10.844v8.045H1.022C.444 18.889 0 19.333 0 19.91v19.067C0 39.556.444 40 1.022 40h26.89c.577 0 1.021-.444 1.021-1.022V19.91c.045-.533-.444-1.022-.977-1.022zm-1.023 19.067H2.044V20.933h24.89v17.023z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#1B6658",
                d: "M13.467 30.133V32c0 .578.444 1.022 1.022 1.022.578 0 1.022-.444 1.022-1.022v-1.867a2.116 2.116 0 001.111-1.866 2.134 2.134 0 00-2.133-2.134c-1.2 0-2.133.934-2.133 2.134 0 .8.444 1.51 1.11 1.866z"
            })
        ]
    });
}
/* harmony default export */ var achievingFinancialFreedom = (AchievingFinancialFreedom);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/financialResiliencePath/index.tsx










const FinancialResilienceList = [
    {
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold",
                    children: "Comprehensive Financial Assessment:"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "It begins with a thorough evaluation of your financial landscape, including your debts, income, and financial aspirations."
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(comprehensiveFinancialAssessment, {})
    },
    {
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold",
                    children: "Personalized Debt Relief Plan:"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Based on this assessment, a tailored debt relief plan is crafted, potentially involving debt settlement negotiations, debt consolidation, credit counseling, or, if necessary, bankruptcy guidance."
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(personalizedDebtReliefPlan, {})
    },
    {
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold",
                    children: "Negotiating for Financial Relief:"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Throughout the process, your chosen debt relief company collaborates with your creditors to secure favorable terms, such as reduced balances or interest rates."
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(negotiatingFinancialRelief, {})
    },
    {
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold",
                    children: "Regular Payments:"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Clients are typically required to make regular contributions to a dedicated account to fund settlements or consolidated payments."
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(regularPayments, {})
    },
    {
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-bold",
                    children: "Achieving Financial Freedom:"
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "As the journey unfolds, you'll witness your debt gradually diminishing, eventually leading to a more manageable financial situation and, in some instances, achieving a debt-free status."
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(achievingFinancialFreedom, {})
    }, 
];
function FinancialResiliencePath() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).mainContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:pt-[97px] lg:pb-[142px] pt-[52px] pb-[82px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
                    featureList: FinancialResilienceList,
                    mainTitle: "The Path to Financial Resilience",
                    mainDescription: "Embarking on the debt relief journey involves a series of pivotal steps aimed at helping you regain your financial footing.",
                    colors: {
                        mainTitleColor: "#1B6658"
                    },
                    classes: {
                        mainSectionClasses: "  ",
                        mainTitleClasses: " text-2xl  lg:text-3xl font-bold text-center sm:text-left",
                        mainDescriptionClasses: "mt-[20px] lg:text-xl lg:leading-8 text-center sm:text-left leading-7 ",
                        innerSectionClasses: "flex   flex-wrap   sm:gap-[88px] gap-[60px] mt-[50px] ",
                        oneBoxClasses: "  w-full max-w-[350px] mx-auto sm:mx-0 sm:w-[310px] ",
                        iconClasses: "children:mx-auto sm:children:mx-0 ",
                        descriptionClasses: `font-light text-center sm:text-left `
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "lg:text-xl lg:leading-8 text-center sm:text-left leading-7 lg:mt-[70px] mt-8",
                    children: "Transparent communication with your debt relief company is pivotal to ensuring a successful outcome."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-6 text-center sm:text-left",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {
                        children: "Claim Your Free Debt Relief Consultation"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 99318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64936);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);








function MainBanner() {
    const { visitDetails , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["checkbox-field"]),
                        all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().field),
                        input: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["input-field"])
                    },
                    fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"]),
                    fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-note"]),
                    fieldErrorMessageClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["field-error-message"]),
                    sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["selling-point"]),
                    formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["progress-background"])
                },
                colors: {
                    primaryColor: "#1B6658",
                    progressBar: "#B3B3B3"
                },
                showProgress: true,
                goToThankYouPage: false,
                sellingPoint: visitDetails?.region ? `${visitDetails?.region}'s Best Debt Relief Companies` : "",
                sellingPointsSteps: "FIRST_STEP",
                dynamicThankYouFields: [
                    "firstName"
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 47446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QualitiesCompany; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
// EXTERNAL MODULE: ./src/components/debtreliefoasis/sharedButton/index.tsx
var sharedButton = __webpack_require__(85523);
;// CONCATENATED MODULE: ./src/components/debtreliefoasis/qualitiesCompany/icons/provenSuccess.tsx


function ProvenSuccess() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#1B6658",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M21.775 26.456c.981 2.113 2.356 3.9 4.163 5.357.28.225.6.4.937.543V36.5h-1.45a.628.628 0 00-.6.45L24.219 39h-1.607a.62.62 0 00-.587.413l-1.362 3.75a.628.628 0 00.075.575.634.634 0 00.512.262h15a.628.628 0 00.587-.844l-1.362-3.75a.62.62 0 00-.587-.412H33.28l-.606-2.05a.63.63 0 00-.6-.444h-1.45v-4.144c.337-.144.663-.319.938-.544a14.734 14.734 0 004.162-5.356c4.306-.5 6.775-3.869 6.775-9.331a.627.627 0 00-.625-.625h-4.388a34.13 34.13 0 00-.087-1.919.627.627 0 00-.625-.581h-16.05c-.325 0-.6.25-.625.581a52.444 52.444 0 00-.088 1.919h-4.387a.627.627 0 00-.625.625c0 5.462 2.469 8.831 6.775 9.331zM35.356 42.75H22.144l.906-2.5h11.4l.906 2.5zM31.975 39h-6.45l.369-1.25h5.712l.369 1.25zm-2.6-2.5h-1.25v-3.8c.206.025.413.05.625.05.212 0 .419-.025.625-.05v3.8zm6.906-11.4c.769-2.138 1.169-4.581 1.213-7.35h3.743c-.106 2.681-.987 6.506-4.956 7.35zm-14.968-9.85h14.875c.424 7.2-1.35 12.3-5.413 15.587-.519.42-1.256.663-2.025.663-.769 0-1.506-.244-2.025-.663-4.069-3.287-5.838-8.387-5.413-15.587zm-1.307 2.5c.038 2.769.444 5.212 1.213 7.35-3.969-.844-4.85-4.669-4.957-7.35h3.744z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M25.806 25.55a.632.632 0 00.225.7.619.619 0 00.738 0l1.981-1.444 1.988 1.444a.618.618 0 00.368.119.62.62 0 00.594-.819l-.756-2.331 1.987-1.444a.62.62 0 00.225-.7.63.63 0 00-.593-.431h-2.457l-.756-2.331a.625.625 0 00-1.188 0l-.756 2.33H24.95a.625.625 0 00-.369 1.132l1.988 1.444-.763 2.331zm2.044-3.656a.625.625 0 00.594-.431l.306-.938.306.938a.625.625 0 00.594.43h.981l-.794.582a.62.62 0 00-.224.7l.306.938-.794-.582a.639.639 0 00-.738 0l-.793.582.306-.938a.632.632 0 00-.225-.7l-.794-.581h.969z"
            })
        ]
    });
}
/* harmony default export */ var provenSuccess = (ProvenSuccess);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/qualitiesCompany/icons/industryAccreditation.tsx


function IndustryAccreditation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#1B6658",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M40.983 39.47l-4.26-7.381a4.1 4.1 0 001.534-4.103 4.101 4.101 0 000-5.47 4.096 4.096 0 00-2.735-4.737 4.102 4.102 0 00-4.737-2.734 4.101 4.101 0 00-5.47 0 4.098 4.098 0 00-4.736 2.735 4.101 4.101 0 00-2.735 4.736 4.1 4.1 0 000 5.47 4.1 4.1 0 001.535 4.103l-4.261 7.382a.876.876 0 00.986 1.285l3.544-.95.95 3.544a.873.873 0 00.848.65.873.873 0 00.758-.438l4.26-7.382a4.066 4.066 0 003.173 0l4.261 7.382a.873.873 0 00.873.43.873.873 0 00.733-.642l.95-3.544 3.544.95a.877.877 0 00.985-1.285zM21.53 43.173a.088.088 0 01-.098.048.09.09 0 01-.081-.071l-1.05-3.92a.388.388 0 00-.477-.277l-3.921 1.05a.09.09 0 01-.103-.034.092.092 0 01-.007-.108l4.25-7.361c.173.087.352.162.536.223a4.101 4.101 0 004.737 2.735c.146.13.3.247.462.354l-4.248 7.361zM26.5 35.34a3.308 3.308 0 01-.794-.586.39.39 0 00-.376-.1 3.32 3.32 0 01-4.061-2.345.39.39 0 00-.276-.276 3.321 3.321 0 01-2.343-4.06.389.389 0 00-.1-.376 3.32 3.32 0 010-4.69.388.388 0 00.1-.376 3.32 3.32 0 012.345-4.06.387.387 0 00.275-.276 3.321 3.321 0 014.06-2.345.393.393 0 00.377-.1 3.32 3.32 0 014.69 0 .394.394 0 00.376.1 3.321 3.321 0 014.061 2.345.387.387 0 00.276.276 3.315 3.315 0 012.344 4.06.388.388 0 00.1.376 3.32 3.32 0 010 4.69.388.388 0 00-.1.376 3.32 3.32 0 01-2.346 4.059.388.388 0 00-.275.275 3.318 3.318 0 01-4.061 2.346.393.393 0 00-.377.1 3.312 3.312 0 01-2.344.97c-.54 0-1.073-.131-1.551-.383zm13.803 4.628a.091.091 0 01-.102.035l-3.923-1.05a.39.39 0 00-.476.275l-1.05 3.92a.098.098 0 01-.18.023l-4.248-7.36c.163-.107.317-.225.462-.354a4.098 4.098 0 004.737-2.735c.184-.061.364-.136.537-.223l4.25 7.361a.092.092 0 01-.007.108z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M35.843 25.251a7.792 7.792 0 10-7.793 7.793 7.8 7.8 0 007.793-7.793zm-14.806 0a7.013 7.013 0 117.014 7.014 7.021 7.021 0 01-7.014-7.014z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M30.569 29.542a.555.555 0 00.697-.137.548.548 0 00.121-.455l-.481-2.807 2.04-1.988a.563.563 0 00-.313-.959l-2.818-.41-1.26-2.554a.563.563 0 00-1.008 0l-1.26 2.553-2.82.41a.563.563 0 00-.31.96l2.039 1.988-.481 2.807a.555.555 0 00.445.644.572.572 0 00.37-.051l2.52-1.325 2.519 1.324zm-5.013-.893l.442-2.576a.388.388 0 00-.112-.345l-1.87-1.824 2.585-.376a.39.39 0 00.293-.212l1.157-2.344 1.156 2.344a.39.39 0 00.294.213l2.586.376-1.872 1.824a.389.389 0 00-.111.345l.442 2.576-2.313-1.216a.388.388 0 00-.363 0l-2.314 1.215z"
            })
        ]
    });
}
/* harmony default export */ var industryAccreditation = (IndustryAccreditation);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/qualitiesCompany/icons/transparentFees.tsx


function TransparentFees() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#1B6658",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M22.715 40.403a8.118 8.118 0 10-8.118-8.118 8.128 8.128 0 008.118 8.118zm0-14.939a6.82 6.82 0 11-6.821 6.821 6.829 6.829 0 016.82-6.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M11 32.285A11.715 11.715 0 1022.715 20.57 11.728 11.728 0 0011 32.285zm11.715-10.417a10.417 10.417 0 11-10.418 10.417 10.43 10.43 0 0110.418-10.417z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M39.936 14H17.32a.648.648 0 00-.649.649v4.634a.648.648 0 00.649.648h23.697v3.544h-7.651a.649.649 0 000 1.297h9.31v3.337h-7.374a.649.649 0 100 1.297h8.758v3.337h-7.79a.649.649 0 000 1.297h3.017v3.337h-4.573a.649.649 0 100 1.297h7.997v3.337H31.014a.648.648 0 100 1.297H43.36a.649.649 0 00.648-.649v-4.634a.648.648 0 00-.648-.648h-2.775V34.04h4.123a.649.649 0 00.65-.648v-4.634a.648.648 0 00-.65-.649h-.734v-3.985a.65.65 0 00-.649-.649h-1.011v-4.192a.648.648 0 00-.649-.649h-1.08v-3.985a.648.648 0 00-.649-.649zm-13.763 4.634h-8.204v-3.337h21.319v3.337H26.172z"
            })
        ]
    });
}
/* harmony default export */ var transparentFees = (TransparentFees);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/qualitiesCompany/icons/personalizedSolutions.tsx


function PersonalizedSolutions() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#1B6658",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M22.715 40.403a8.118 8.118 0 10-8.118-8.118 8.128 8.128 0 008.118 8.118zm0-14.939a6.82 6.82 0 11-6.821 6.821 6.829 6.829 0 016.82-6.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M11 32.285A11.715 11.715 0 1022.715 20.57 11.728 11.728 0 0011 32.285zm11.715-10.417a10.417 10.417 0 11-10.418 10.417 10.43 10.43 0 0110.418-10.417z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M39.936 14H17.32a.648.648 0 00-.649.649v4.634a.648.648 0 00.649.648h23.697v3.544h-7.651a.649.649 0 000 1.297h9.31v3.337h-7.374a.649.649 0 100 1.297h8.758v3.337h-7.79a.649.649 0 000 1.297h3.017v3.337h-4.573a.649.649 0 100 1.297h7.997v3.337H31.014a.648.648 0 100 1.297H43.36a.649.649 0 00.648-.649v-4.634a.648.648 0 00-.648-.648h-2.775V34.04h4.123a.649.649 0 00.65-.648v-4.634a.648.648 0 00-.65-.649h-.734v-3.985a.65.65 0 00-.649-.649h-1.011v-4.192a.648.648 0 00-.649-.649h-1.08v-3.985a.648.648 0 00-.649-.649zm-13.763 4.634h-8.204v-3.337h21.319v3.337H26.172z"
            })
        ]
    });
}
/* harmony default export */ var personalizedSolutions = (PersonalizedSolutions);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/qualitiesCompany/icons/privacyAndSupport.tsx


function PrivacyAndSupport() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#1B6658",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M39.34 43.238V25.146a.762.762 0 00-.763-.762h-2.996v-2.981c0-1.963-.78-3.846-2.17-5.235a7.415 7.415 0 00-10.481 0 7.399 7.399 0 00-2.171 5.235v2.985h-2.996a.764.764 0 00-.763.762v18.088a.762.762 0 00.763.762h20.814a.764.764 0 00.763-.762zM22.285 21.403c0-1.56.62-3.054 1.724-4.157a5.888 5.888 0 018.322 0 5.875 5.875 0 011.724 4.157v2.985h-11.77v-2.985zm15.529 21.072H18.526V25.908h19.288v16.567z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M27.357 37.175v2.995h1.627v-2.995a2.861 2.861 0 001.604-1.135 2.582 2.582 0 00.425-1.848 2.668 2.668 0 00-.963-1.66 2.977 2.977 0 00-1.88-.66c-.69 0-1.358.235-1.88.66a2.668 2.668 0 00-.963 1.66c-.098.644.052 1.3.425 1.848s.942.951 1.605 1.136zm.813-3.769a1.3 1.3 0 01.692.198c.205.129.364.312.458.527.095.214.12.45.071.678a1.154 1.154 0 01-.34.6 1.27 1.27 0 01-.638.322 1.316 1.316 0 01-.72-.067 1.232 1.232 0 01-.558-.433 1.126 1.126 0 01-.21-.651c0-.311.131-.61.365-.83.233-.22.55-.344.88-.344z"
            })
        ]
    });
}
/* harmony default export */ var privacyAndSupport = (PrivacyAndSupport);

;// CONCATENATED MODULE: ./src/components/debtreliefoasis/qualitiesCompany/index.tsx









const FinancialResilienceList = [
    {
        title: "Proven Success:",
        description: "Seek a company with a track record of helping clients effectively reduce or manage their debts.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(provenSuccess, {})
    },
    {
        title: "Industry Accreditation:",
        description: " Accreditation from respected organizations like the American Fair Credit Council (AFCC) or the International Association of Professional Debt Arbitrators (IAPDA) strongly indicates credibility.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(industryAccreditation, {})
    },
    {
        title: "Transparent Fees:",
        description: `
                    Ensure they explain their fees clearly and maintain
                    reasonable and transparent cost structures to prevent
                    unexpected expenses.
           `,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(transparentFees, {})
    },
    {
        title: "Personalized Solutions:",
        description: `
                    A reputable debt relief company tailors its solutions to
                    your unique financial circumstances and requirements.
           `,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(personalizedSolutions, {})
    },
    {
        title: "Privacy and Support:",
        description: `They should prioritize your privacy and data security and
                    offer exceptional customer support throughout your debt
                    relief journey.`,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyAndSupport, {})
    }, 
];
function QualitiesCompany() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:mt-[97px] lg:mb-[142px] mt-[52px] mb-[82px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
                featureList: FinancialResilienceList,
                mainTitle: "Qualities of a Trustworthy Debt Relief Company",
                mainDescription: "Identifying Your Ideal Debt Relief Partner When searching for a reputable debt relief company, several essential factors should top your checklist:",
                colors: {
                    mainTitleColor: "#1B6658",
                    titleColor: "#1B6658"
                },
                classes: {
                    mainSectionClasses: "  ",
                    mainTitleClasses: " text-2xl  lg:text-3xl font-bold text-center sm:text-left",
                    titleClasses: "text-xl  lg:text-2xl font-bold mt-[30px] text-center sm:text-left",
                    mainDescriptionClasses: "mt-[20px] lg:text-xl lg:leading-8 text-center sm:text-left leading-7 ",
                    innerSectionClasses: "flex   flex-wrap   sm:gap-[88px] gap-[60px] mt-[50px] ",
                    oneBoxClasses: "  w-full  mx-auto sm:mx-0 sm:w-[500px]  ",
                    iconClasses: "children:mx-auto sm:children:mx-0 ",
                    descriptionClasses: `font-light text-center sm:text-left mt-[5px]`
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "lg:text-xl lg:leading-8 text-center sm:text-left leading-7 lg:mt-[70px] mt-8",
                children: "Reading client reviews and testimonials can also offer invaluable insights into the company's reputation and customer satisfaction."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 text-center sm:text-left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {
                    children: "Begin Your Journey to Debt Freedom"
                })
            })
        ]
    });
}


/***/ }),

/***/ 85523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63828);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton({ children  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `   py-4 sm:px-16 px-4 sm:text-lg font-semibold rounded-[13px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)} `,
        children: children
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 90010:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__W_i3d"};

/***/ }),

/***/ 65748:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__XcYO4"};

/***/ }),

/***/ 64936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","selling-point":"styles_selling-point__vqSJn","main-banner":"styles_main-banner__raOE7","form":"styles_form__5EWVS","step":"styles_step___Sqfu","form-field":"styles_form-field__8rwjZ","step-title":"styles_step-title__XYhLu","steps-inner":"styles_steps-inner__G8SIx","label-as-step-title":"styles_label-as-step-title__WTCIi","step-description":"styles_step-description__Fv24y","fields-wrapper":"styles_fields-wrapper__VMcRh","form-button":"styles_form-button__T6E9_","radio-field":"styles_radio-field__tC_Vv","checkbox-field":"styles_checkbox-field__3ngHS","field-note":"styles_field-note__yrDtc","input-field":"styles_input-field__Vnpak","field-error-message":"styles_field-error-message__HiTrX","field":"styles_field__BHApc","tcpa":"styles_tcpa__ZRkRT","image":"styles_image__eMxgV"};

/***/ }),

/***/ 63828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__UPiTl"};

/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);